import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import dayjs from 'dayjs';


@Component
export default class StatusRecordBarChart extends Vue {
  @Prop({ default: () => ([]) }) readonly columns: Array<any>;
  @Prop({ default: () => ([]) }) readonly dataValue: any;
  @Prop({ default: () => ([]) }) readonly color: Array<any>;
  @Prop({ default: '' }) readonly dateTime: string;

  mounted() {
    this.init()
  }

  renderItem(params, api) {
    var categoryIndex = api.value(0);
    var start = api.coord([api.value(1), categoryIndex]);
    var end = api.coord([api.value(2), categoryIndex]);
    var height = api.size([0, 1])[1] * 0.6;

    var rectShape = (this as any).$echarts.graphic.clipRectByRect({
      x: start[0],
      y: start[1] - height / 2,
      width: end[0] - start[0],
      height: height
    }, {
      x: params.coordSys.x,
      y: params.coordSys.y,
      width: params.coordSys.width,
      height: params.coordSys.height
    });

    return rectShape && {
      type: 'rect',
      shape: rectShape,
      style: api.style()
    };
  }

  init() {
    var myChart = (this as any).$echarts.init(
      this.$refs.myChart
    );
    const categories = []
    this.dataValue.forEach(res => {
      categories.push(res.workStation.workStationName)
    });
    console.log(categories,'<==categories')
    const types = []
    this.columns.forEach((res, index) => {
      const data = {
        name: res.collectStatusName,
        color: res.color,
        collectStatus: res.collectStatus
      }
      types.push(data)
    })
    const seriesdata = []
    let minTime = dayjs(this.dateTime).valueOf();
    let maxTime = dayjs(this.dateTime).valueOf() + (7200000 * 12) - 1
    const that = this as any

    if(dayjs(this.dateTime).get('year') < 2022 && that.dataValue && that.dataValue.length){
      minTime = dayjs(that.dataValue[0].recordItems[0].date).valueOf();
      maxTime = dayjs(that.dataValue[0].recordItems[0].date).valueOf() + (7200000 * 12) - 1
    }

    (this as any).$echarts.util.each(categories, function (category, index) {
      const dataCount = that.dataValue[that.dataValue.length - index - 1].recordItems;

      if(dataCount.length > 0) {
        dataCount.forEach(item => {
          const typeItem = types.find(res => res.collectStatus == item.iotStatus) || {};
          const baseTime = dayjs(item.startTime).valueOf()
          // 修复不能绘制完成
          const endTime = dayjs(item.endTime).valueOf() - 1
          const duration = item.endTime - item.startTime
          seriesdata.push({
            name: typeItem.name,
            value: [
              index,
              baseTime,
              endTime,
              duration
            ],
            itemStyle: {
              normal: {
                color: typeItem.color
              }
            }
          });
          
        });
      }
    });
    console.log(seriesdata, '<==cat')
    var option = {
      tooltip: {
        formatter: function (params) {
          return params.marker + params.name + ': ' + dayjs(params.value[1]).format('HH:mm:ss') + ' ~ ' + dayjs(params.value[2]).format('HH:mm:ss');
        }
      },
      title: {
        show: false
      },
      grid: {
        left: '10%',
        right: this.dataValue.length < 10 ? '3%' : '45',
        bottom: '45',
        top: '45',
      },
      xAxis: {
        min: minTime,
        max: maxTime,
        type: 'value',
        left: '1%',
        position: 'top',
        scale: true,
        interval: 7200000,
        axisLabel: {
          show: true,
          interval: 0,
          formatter: (val) => {
            var strs = dayjs(val).format('HH:mm').split(''); //字符串数组
            var str = ''
            for(var i = 0, s; s = strs[i++];) { //遍历字符串数组
            str += s;
            if(!(i % 8)) str += '\n'; //按需要求余
            }
            return str
          },
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: 'dashed'
          }
        },
      },
      yAxis: {
        data: categories.reverse(),
        boundaryGap: true,
        inverse: true,
        axisLine: {
          show: false
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: 'dashed'
          }
        },
      },      
      dataZoom: [
        {
          show: true,
          type: "slider",
          xAxisIndex: 0,
          brushSelect: false,
          filterMode: 'none',
          start: 0,
          end: 100,
          width: '70%',
          left: '20%',
          labelFormatter: function (value) {
            return dayjs(value).format('MM/DD HH:mm');
          }
        },
        {
          show: this.dataValue.length > 10 ,
          type: "slider",
          yAxisIndex: 0,
          brushSelect: false,
          zoomLock: true,
          filterMode: 'none',
          height: '90%',
          showDetail: false,
          start: 0,
          end: this.dataValue.length > 10  ? ((10 / this.dataValue.length ) * 100).toFixed(2) : 100
        }
      ],
      series: [{
        type: 'custom',
        renderItem: this.renderItem,
        itemStyle: {
          opacity: 0.8
        },
        encode: {
          x: [1, 2],
          y: 0
        },
        data: seriesdata
      }]
    }
    // 使用刚指定的配置项和数据显示图表。
    myChart.setOption(option);
  }

  getWidth(){
    const div = document.getElementById('black-main')
    return div.clientWidth - 15 + 'px'
  }

  getHeight(){
    const div = document.getElementById('black-main')
    return div.clientHeight - 115
  }

  render() {
    return (
      <div ref="myChart" style={{ width: this.getWidth(), height: this.getHeight() + 'px' }}></div>
    )
  }
}
